/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
} from '../../../coreui';

import StrategySection1 from './components/StrategySection1';
import StrategySection2 from './components/StrategySection2';

class Strategy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };

    this.handleSensorChange = this.handleSensorChange.bind(this);
  }

  handleSensorChange(isVisible) {
    if (isVisible) {
      this.setState({
        isVisible,
      });
    }
  }

  render() {
    return (
      <ExtendedFlex
        flexDirection={['column', 'column', 'row', 'row', 'row']}
      >
        <StrategySection1
          handleSensorChange={this.handleSensorChange}
          {...this.state}
          {...this.props}
        />
        <StrategySection2
          {...this.state}
        />
      </ExtendedFlex>
    );
  }
}

Strategy.propTypes = {
  isLoggedIn: PropTypes.bool,
};

export default Strategy;
